module.exports = __webpack_public_path__ + "img/d16a2799180b57cbafab65627e8a5de5.png";